export default __webpack_public_path__ + "static/button-item-do-f26c08e7a7b6b46b6b23560a3c825c6f.png";